import type { PreferenceProfile, ReaderPreference } from "../api";

export async function createPreferenceProfile(input: {
  userId: string;
  name: string;
  preference: ReaderPreference;
  isActive: boolean;
}): Promise<PreferenceProfile> {
  const response = await fetch("/api/preferences", {
    method: "POST",
    body: JSON.stringify(input),
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  });
  const body = await response.json();

  if (!response.ok) {
    throw new Error(body.error ?? "阅读偏好创建失败");
  }

  return body;
}
